import { useEffectOverlay } from '@hooks/use-effect-overlay'
import { Modal, type ModalProps } from '@ui/atoms/modal'
import React, { type FC } from 'react'

import { useIsIframe } from '../../../../plugins/gatsby-plugin-espace-client'

export const ModalUI: FC<ModalProps> = ({
  fullScreen = false,
  visible,
  children,
  ...modalProps
}) => {
  const isIframe = useIsIframe()
  useEffectOverlay(visible)

  return (
    <Modal
      className="!z-[10000]"
      fullScreen={isIframe || fullScreen}
      visible={visible}
      {...modalProps}
    >
      {children}
    </Modal>
  )
}
